import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Nav from "react-bootstrap/Nav";
import { Helmet } from "react-helmet";
import React from "react";
import Form from "react-bootstrap/Form";

import Image from "react-bootstrap/Image";
import { Row, Col, Container, Button } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// Banner images
import bannerAI from "../assets/images/banner/GCC-banner.png";
import bannerSalesforce from "../assets/images/banner/comsense-crest.png";
import bannerMartechAward from "../assets/images/banner/FEConnect-Awards.jpg";

import offerImageOne from "../assets/images/offerBoxImageOne.png";
import offerImageTwo from "../assets/images/offerBoxImageTwo.png";
import offerImageThree from "../assets/images/offerBoxImageThree.png";
import offerImageFour from "../assets/images/offerBoxImageFour.png";
import offerImageFive from "../assets/images/offerBoxImageFive.png";
import offerImageSix from "../assets/images/offerBoxImageSix.png";
import offerImageSeven from "../assets/images/offerBoxImageSeven.png";
import offerImageEight from "../assets/images/offerBoxImageEight.png";
import arrow from "../assets/images/right-arrow.png";
import leftImageOne from "../assets/images/left-image-one.png";
import quote from "../assets/images/quote.png";
import clientAdidas from "../assets/images/client-adidas.png";
import strategyAndConsultingIcon from "../assets/images/Strategy-and-Consulting-icon.png";
import Implementation from "../assets/images/Implementation.png";
import ManagedServices from "../assets/images/Managed-Services.png";

// Importing client_1 to client_27, all pointing to the same file
// Importing client_1 to client_41 from the "brands" folder
import client_1 from "../assets/images/clients/brands/adidas.png";
import client_2 from "../assets/images/clients/brands/reebok.png";
import client_3 from "../assets/images/clients/brands/marks.png";
import client_13 from "../assets/images/clients/brands/ambit.png";
import client_15 from "../assets/images/clients/brands/metropolis.png";
import client_21 from "../assets/images/clients/brands/tata-motors.png";
import client_22 from "../assets/images/clients/brands/royal-enfield.png";
import client_23 from "../assets/images/clients/brands/AirAsia.png";
import client_32 from "../assets/images/clients/brands/ladakh.png";
import client_33 from "../assets/images/clients/brands/house-of-abhinandan.png";

import { IoIosStar } from "react-icons/io";
import {
  FaTrophy,
  FaArrowRight,
  FaBolt,
  FaChartLine,
  FaAward,
  FaRobot,
} from "react-icons/fa";
import {
  Rocket,
  TrendingDown,
  Target,
  RotateCcw,
} from "lucide-react";

import caseStudy from "../assets/pdf/img/SalesforceAndComsense.jpeg";
import LayerTwo from "../assets/images/layers/Layer_2.png";
import LayerThree from "../assets/images/layers/Layer_3.png";
import LayerFour from "../assets/images/layers/Layer_4.png";
import bannerShape1 from "../assets/images/layers/banner_layer_one.png";
import bannerShape2 from "../assets/images/layers/banner_layer_two.png";
import enquirySuccess from "../assets/images/enquiry-success.png";
import "../assets/css/contact.css";

import clientTataMotors from "../assets/images/clients/tata-motor.png";

import DataReadinessModal from "./DataReadinessModal";
import Modal from "react-bootstrap/Modal";
import CaseStudyModal from "./CaseStudyModal";

import offerImageNine from "../assets/images/offerBoxImageNine.png";
import offerImageTen from "../assets/images/offerBoxImageTen.png";
import offerImageEleven from "../assets/images/offerBoxImageEle.png";
import { apiUrl, apiHeaders } from "../apiConfig";

const HERO_AUTOPLAY_MS = 6000;

const clientImages = [
  client_1,
  client_2,
  client_3,
  client_15,
  client_13,
  client_21,
  client_22,
  client_23,
  client_32,
  client_33,
];

const Home = () => {
  const [, setIsFluid] = useState(true);
  const [, setCurrentSlide] = useState(0);
  const sliderRef = React.useRef(null);


  useEffect(() => {
    const handleResize = () => {
      // Switch to 'container' if the width is less than a threshold (e.g., 1400px)
      setIsFluid(window.innerWidth < 1400);
    };

    // Initial check on mount
    handleResize();

    // Listen for window resize
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    responsive: [
      {
        breakpoint: 992, // Tablets and below
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // Mobile devices
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  // Modal handlers (separate states for Data Readiness and Case Study modals)
  const [showDataReadinessModal, setShowDataReadinessModal] = useState(false);
  const [showCaseStudyModal, setShowCaseStudyModal] = useState(false);
  const [, setIsSubmitted] = useState(false);

  const openDataReadinessModal = () => setShowDataReadinessModal(true);
  const closeDataReadinessModal = () => {
    setShowDataReadinessModal(false);
    setIsSubmitted(false); // Reset the state when the modal closes
  };

  const openCaseStudyModal = () => setShowCaseStudyModal(true);
  const closeCaseStudyModal = () => setShowCaseStudyModal(false);

  /*contact form*/
  const emptyForm = { name: "", email: "", mobile: "", company: "", message: "" };
  const [formData, setFormData] = useState(emptyForm);
  const [enquirySent, setEnquirySent] = useState(false);

  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");

  // Email validation regex (blocks free providers)
  const businessEmailRegex =
    /@(gmail\.com|yahoo\.com|outlook\.com|hotmail\.com|aol\.com|icloud\.com|protonmail\.com|zoho\.com|mail\.com|gmx\.com)$/i;

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");

    const { name, email, mobile, company, message } = formData;

    // Validate required fields
    if (!name || !email || !mobile || !company || !message) {
      setResponseMessage("Please fill in all required fields.");
      setLoading(false);
      return;
    }

    // Validate business email
    if (businessEmailRegex.test(email)) {
      setResponseMessage("Please enter a valid business email address.");
      setLoading(false);
      return;
    }

    if (!/^\d{10}$/.test(mobile.replace(/[^\d]/g, ""))) {
      setResponseMessage("Please enter a valid 10-digit mobile number.");
      setLoading(false);
      return;
    }

    try {
      // The server builds and sends the emails; SMTP credentials stay server-side
      const res = await fetch(apiUrl("/api/enquiry"), {
        method: "POST",
        headers: apiHeaders,
        body: JSON.stringify(formData),
      });
      const response = await res.json().catch(() => null);
      if (!response) {
        // Non-JSON reply: the API server is down or restarting
        setResponseMessage("We couldn’t reach our server. Please try again in a moment.");
      } else if (res.ok && response.success) {
        setResponseMessage("");
        setEnquirySent(true);
        setFormData(emptyForm);
      } else {
        setResponseMessage(
          response.message || "Failed to send email. Please try again."
        );
      }
    } catch (error) {
      setResponseMessage("We couldn’t reach our server. Please try again in a moment.");
    }

    setLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>
          Salesforce & AI Solutions Company in Pune | Comsense Technology
        </title>

        <meta
          name="description"
          content="Salesforce & AI partner in Pune for agentic enterprises. Transform data into insights with Data Cloud, Martech & analytics solutions."
        />

        <meta
          name="keywords"
          content="Salesforce consulting Pune, AI data solutions India, Martech company Pune, Salesforce and AI partner for agentic enterprises"
        />

        <meta name="robots" content="index, follow" />
        <meta name="author" content="Comsense Technologies" />

        {/* Open Graph */}
        <meta
          property="og:title"
          content="Salesforce & AI Solutions Company in Pune | Comsense Technologies"
        />
        <meta
          property="og:description"
          content="Transform your business with Salesforce, AI, Data Cloud & Martech solutions in Pune."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.comsensetechnologies.com/"
        />

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Comsense Technologies Private Limited",
            url: "https://comsensetechnologies.com/",
            logo: "https://comsensetechnologies.com/static/media/black-logo.161c2662f20cade7cdf6.png",
            sameAs: [
              "https://www.instagram.com/comsensemktg/#",
              "https://x.com/ComsenseTech",
              "https://www.youtube.com/channel/UCCekynsEDZS7VORzB5KwX9g",
              "https://www.linkedin.com/company/comsense-consulting/",
            ],
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "WebSite",
            name: "Comsense Technologies Pvt. Ltd.",
            url: "https://comsensetechnologies.com/",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://comsensetechnologies.com/{search_term_string}",
              "query-input": "required name=search_term_string",
            },
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ProfessionalService",
            name: "Comsense Technologies Private Limited",
            image: "",
            "@id": "",
            url: "https://comsensetechnologies.com/",
            telephone: "091756 75679",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Ganeshkhind Rd, Shivajinagar",
              addressLocality: "Pune",
              postalCode: "411016",
              addressCountry: "IN",
            },
            geo: {
              "@type": "GeoCoordinates",
              latitude: 18.53508,
              longitude: 73.83816,
            },
            sameAs: [
              "https://www.youtube.com/channel/UCCekynsEDZS7VORzB5KwX9g",
              "https://www.instagram.com/comsensemktg/#",
              "https://x.com/ComsenseTech",
              "https://www.linkedin.com/company/comsense-consulting/",
            ],
          })}
        </script>

        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org/",
            "@type": "BreadcrumbList",
            itemListElement: [
              {
                "@type": "ListItem",
                position: 1,
                name: "Homepage",
                item: "https://comsensetechnologies.com/",
              },
              {
                "@type": "ListItem",
                position: 2,
                name: "Salesforce Data Cloud",
                item: "https://comsensetechnologies.com/data-cloud",
              },
              {
                "@type": "ListItem",
                position: 3,
                name: "Salesforce Marketing Cloud",
                item: "https://comsensetechnologies.com/marketing-cloud",
              },
              {
                "@type": "ListItem",
                position: 4,
                name: "Salesforce Service Cloud",
                item: "https://comsensetechnologies.com/service-cloud",
              },
              {
                "@type": "ListItem",
                position: 5,
                name: "Salesforce Tableau",
                item: "https://comsensetechnologies.com/tableau",
              },
              {
                "@type": "ListItem",
                position: 6,
                name: "Salesforce Marketing Cloud Personalization",
                item: "https://comsensetechnologies.com/marketing-cloud-personalization",
              },
              {
                "@type": "ListItem",
                position: 7,
                name: "Salesforce Agentforce",
                item: "https://comsensetechnologies.com/agent-force",
              },
              {
                "@type": "ListItem",
                position: 8,
                name: "About us",
                item: "https://comsensetechnologies.com/about",
              },
            ],
          })}
        </script>
      </Helmet>
      {/* <header class="masthead z-0 pt-0">
               <a href="/AI-First-Delivery-Center"><Image src={banner2} className='w-100' /></a>
            </header> */}

      <header class="masthead z-0">
        <div class="container text-left">
          <Image
            src={bannerShape1}
            className="z-n1 position-absolute top-0 start-0 w-40 d-none d-md-block"
          />

          <Slider
            ref={sliderRef}
            dots={false}
            infinite={true}
            speed={700}
            fade={true}
            slidesToShow={1}
            slidesToScroll={1}
            autoplay={true}
            autoplaySpeed={HERO_AUTOPLAY_MS}
            pauseOnHover={true}
            className="header-slider hero-modern-slider"
            arrows={false}
            beforeChange={(_, next) => setCurrentSlide(next)}
          >
            <div className="px-0">
              <div className="hero-modern d-flex flex-column flex-lg-row align-items-center gap-5 gap-lg-0">
                <div className="hero-modern-content flex-grow-1 w-100 w-lg-50 text-center text-lg-start">
                  <span className="hero-modern-badge">
                    <span className="hero-modern-badge-dot" />
                    Salesforce + AI Partner
                  </span>
                  <div class="masthead-heading fw-700 text-252B42 mb-3">
                    We are the <span className="hero-modern-highlight">#1</span>{" "}
                    Trusted{" "}
                    <span className="hero-modern-accent">
                      Sales<span style={{ fontStyle: "italic" }}>f</span>orce
                    </span>{" "}
                    + AI partner for Agentic Enterprises
                  </div>
                  <h2 className="hero-modern-tagline">
                    <span>Data-First</span>
                    <span>AI-Ready</span>
                    <span>Salesforce-Powered</span>
                  </h2>
                  <p className="hero-modern-desc">
                    Comsense helps enterprises move from digital transformation
                    to Agentic Transformation — where Data, AI, and execution
                    work seamlessly to deliver measurable business outcomes.
                  </p>
                  <div className="d-flex flex-column flex-sm-row flex-wrap flex-xl-nowrap justify-content-center justify-content-lg-start gap-3">
                    <Nav.Link
                      className="hero-modern-btn text-white btn btn-danger btn-xl"
                      onClick={openDataReadinessModal}
                    >
                      Get Your Free Data Readiness{" "}
                      <FaArrowRight className="ms-2" />
                    </Nav.Link>
                    <Nav.Link
                      className="hero-modern-btn text-white btn outline-btn-danger btn-xl"
                      as={Link}
                      to="/smart-solutions"
                    >
                      Explore Smart Solutions
                    </Nav.Link>
                  </div>
                </div>
                <div className="flex-grow-1 w-100 w-lg-50 ps-lg-5">
                  <div className="hero-modern-visual">
                    <Image
                      src={bannerSalesforce}
                      alt="Comsense - Salesforce Crest Partner"
                      className="hero-modern-img"
                    />
                    <div className="hero-modern-float hero-modern-float-top">
                      <span className="hero-modern-float-icon">
                        <FaAward />
                      </span>
                      <span>
                        <strong>Crest Partner</strong>
                        <small>Salesforce</small>
                      </span>
                    </div>
                    <div className="hero-modern-float hero-modern-float-bottom">
                      <span className="hero-modern-float-icon hero-modern-float-icon-blue">
                        <FaRobot />
                      </span>
                      <span>
                        <strong>Agentforce + Data 360</strong>
                        <small>AI-ready delivery</small>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-0">
              <div className="hero-modern d-flex flex-column flex-lg-row align-items-center gap-5 gap-lg-0">
                <div className="hero-modern-content flex-grow-1 w-100 w-lg-50 text-center text-lg-start">
                  <span className="hero-modern-badge">
                    <span className="hero-modern-badge-dot" />
                    Global Capability Center
                  </span>
                  <div class="masthead-heading fw-700 text-252B42 mb-3">
                    Launch Your Data & AI{" "}
                    <span className="hero-modern-accent">GCC</span> in{" "}
                    <span className="hero-modern-highlight">90 Days</span>
                  </div>
                  <h2 className="hero-modern-tagline">
                    <span>Outcome-led</span>
                    <span>Zero-Capex</span>
                    <span>Built to Scale</span>
                  </h2>
                  <p className="hero-modern-desc">
                    Comsense redefines GCCs with an AI-first, outcome-led model,
                    replacing traditional build approaches with agile,
                    execution-ready capability pods designed for speed and
                    scalability.
                  </p>
                  <ul className="hero-modern-stats list-unstyled">
                    <li>
                      <span className="hero-modern-stat-icon">
                        <Rocket size={18} strokeWidth={2} />
                      </span>
                      <div>
                        <strong>3x</strong>
                        <span>Faster deployment vs traditional models</span>
                      </div>
                    </li>
                    <li>
                      <span className="hero-modern-stat-icon is-blue">
                        <TrendingDown size={18} strokeWidth={2} />
                      </span>
                      <div>
                        <strong><small>Up to</small> 50%</strong>
                        <span>Cost optimization</span>
                      </div>
                    </li>
                    <li>
                      <span className="hero-modern-stat-icon is-dark">
                        <Target size={18} strokeWidth={2} />
                      </span>
                      <div>
                        <span>Business Outcomes in</span>
                        <strong>90 Days</strong>
                      </div>
                    </li>
                  </ul>
                  <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-lg-start gap-3">
                    <Nav.Link
                      className="hero-modern-btn text-white btn btn-danger btn-xl"
                      as={Link}
                      to="../contact"
                    >
                      Build Your GCC Roadmap <FaArrowRight className="ms-2" />
                    </Nav.Link>
                    <Nav.Link
                      className="hero-modern-btn text-white btn outline-btn-danger btn-xl"
                      as={Link}
                      to="/global-capability-center/GCC"
                    >
                      Explore Our Approach
                    </Nav.Link>
                  </div>
                </div>
                <div className="flex-grow-1 w-100 w-lg-50 ps-lg-5">
                  <div className="hero-modern-visual">
                    <Image
                      src={bannerAI}
                      alt="Leadership team in a global capability center boardroom"
                      className="hero-modern-img"
                    />
                    <div className="hero-modern-float hero-modern-float-top">
                      <span className="hero-modern-float-icon">
                        <FaBolt />
                      </span>
                      <span>
                        <strong>AI-first</strong>
                        <small>Capability pods</small>
                      </span>
                    </div>
                    <div className="hero-modern-float hero-modern-float-bottom">
                      <span className="hero-modern-float-icon hero-modern-float-icon-blue">
                        <FaChartLine />
                      </span>
                      <span>
                        <strong>Zero-Capex</strong>
                        <small>Outcome-led model</small>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-0">
              <div className="hero-modern d-flex flex-column flex-lg-row align-items-center gap-5 gap-lg-0">
                <div className="hero-modern-content flex-grow-1 w-100 w-lg-50 text-center text-lg-start">
                  <span className="hero-modern-badge">
                    <span className="hero-modern-badge-dot" />
                    Awards & Recognition
                  </span>
                  <div class="masthead-heading fw-700 text-252B42 mb-4">
                    Award-Winning{" "}
                    <span className="hero-modern-accent">MarTech</span>{" "}
                    <span className="hero-modern-highlight">Excellence</span>
                  </div>
                  <ul className="hero-modern-awards list-unstyled">
                    {[
                      {
                        title:
                          "Excellence in Marketing Automation & Journey Orchestration",
                        client: "Tata Motors Ltd.",
                      },
                      {
                        title:
                          "Excellence in Marketing Analytics & Insight Platform",
                        client: "Royal Enfield India",
                      },
                      {
                        title: "Excellence in the Use of MarTech in Automotive",
                        client: "Royal Enfield India",
                      },
                    ].map((award) => (
                      <li key={award.title}>
                        <span className="hero-modern-award-icon">
                          <FaTrophy />
                        </span>
                        <span>
                          <strong>{award.title}</strong>
                          <small>
                            for its work with <em>{award.client}</em>
                          </small>
                        </span>
                      </li>
                    ))}
                  </ul>
                  <div className="d-flex flex-column flex-sm-row justify-content-center justify-content-lg-start gap-3">
                    <Nav.Link
                      className="hero-modern-btn text-white btn btn-danger btn-xl"
                      as={Link}
                      to="/press-releases/comsense-technologies-wins-three-prestigious-martech-awards-for-customer-experience-and-marketing-innovation"
                    >
                      Read The Press Release <FaArrowRight className="ms-2" />
                    </Nav.Link>
                  </div>
                </div>
                <div className="flex-grow-1 w-100 w-lg-50 ps-lg-5">
                  <div className="hero-modern-visual">
                    <Image
                      src={bannerMartechAward}
                      alt="Comsense team receiving MarTech Awards 2026"
                      className="hero-modern-img"
                    />
                    <div className="hero-modern-float hero-modern-float-top">
                      <span className="hero-modern-float-icon">
                        <FaTrophy />
                      </span>
                      <span>
                        <strong>3 Awards</strong>
                        <small>MarTech Awards 2026</small>
                      </span>
                    </div>
                    <div className="hero-modern-float hero-modern-float-bottom">
                      <span className="hero-modern-float-icon hero-modern-float-icon-blue">
                        <FaAward />
                      </span>
                      <span>
                        <strong>FE Connect</strong>
                        <small>Financial Express</small>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Slider>

          <Image
            src={bannerShape2}
            className="z-n1 position-absolute bottom-0 end-0 w-40 opacity-25 d-none d-md-block"
          />
        </div>
      </header>

      {/* <header class="masthead z-0">
        <div class="container text-left">
          <Image
            src={bannerShape1}
            className="z-n1 position-absolute top-0 start-0 w-40 d-none d-md-block"
          />


          <Row className="d-flex align-items-center">
            <Col lg="6">

              <div class="masthead-heading fw-700 text-252B42 mb-3">
                We are the <span style={{ color: "#ee0000" }}>#1</span> Trusted{" "}
                <span style={{ color: "#0895cc" }}>
                  Sales<span style={{ fontStyle: "italic" }}>f</span>orce
                </span>{" "}
                + AI partner for Agentic Enterprises
              </div>
              <h2 className="section-heading section-heading-start text-left fw-700 fs-4">
                Data-First. AI-Ready. Salesforce-Powered.
              </h2>
              <p className="text-left !text-xs mb-5">
                Comsense helps enterprises move from digital transformation to
                Agentic Transformation — where Data, AI, and execution work
                seamlessly to deliver measurable business outcomes.
              </p>
              <div className="d-block d-sm-flex gap-2">
                <Nav.Link
                  className="mb-2 mb-sm-0 text-white btn btn-danger btn-xl me-3"
                  onClick={openDataReadinessModal}
                >
                  Get Your Free Data <br />
                  Readiness
                </Nav.Link>
                <Nav.Link
                  className="text-white btn outline-btn-danger btn-xl me-3"
                  as={Link}
                  to="/smart-solutions"
                >
                  Explore Our Salesforce <br />
                  Smart Solutions
                </Nav.Link>
              </div>
            </Col>
            <Col lg="6">
              <Image
                src={bannerSalesforce}
                className="w-100 img-shape slider-img pe-0 ps-lg-5"
              />

            </Col>
          </Row>

          <Image
            src={bannerShape2}
            className="z-n1 position-absolute bottom-0 end-0 w-40 opacity-25 d-none d-md-block"
          />
        </div>
      </header> */}

      <section id="offer-area" class="page-section pt-0 offer-area">
        {/* <Container fluid={isFluid ? true : undefined}> */}
        <Container fluid>
          <Row className="h-100 mt-4 mt-lg-0 mt-md-0">
            {/* Column 1 */}
            <Col
              lg={4}
              md={6}
              sm={6}
              xs={12}
              className="d-flex flex-column mb-5 mb-sm-0"
            >
              <div className="d-flex flex-column flex-grow-1 justify-content-center align-items-center text-center">
                <h2 class="section-heading section-heading-center fw-700 fs-2">
                  <span className="bordered-text bordered-text-start">
                    What
                  </span>{" "}
                  We Offer
                </h2>
              </div>
            </Col>

            {/* Column 2 */}
            <Col lg={4} md={6} sm={6} xs={12} className="d-flex flex-column">
              <Row className="h-100 flex-grow-1 mb-3 mb-md-0">
                <Col lg={6} sm={6} xs={6} className="d-flex flex-column">
                  <div
                    className="offer-box d-flex flex-column flex-grow-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/data-cloud";
                    }}
                  >
                    <div className="mt-auto">
                      <h3>Data 360</h3>
                      <p className="text-left">
                        Unify data for personalized marketing and a single
                        customer view.
                      </p>
                    </div>
                    <Nav.Link as={Link} to="../data-cloud">
                      <Image
                        src={arrow}
                        className="arrow mt-2 align-self-start"
                      />
                    </Nav.Link>
                  </div>
                </Col>
                <Col
                  lg={6}
                  sm={6}
                  xs={6}
                  className="d-flex align-items-stretch"
                >
                  <Image
                    className="w-100 h-100 object-fit-cover"
                    src={offerImageOne}
                  />
                </Col>
              </Row>
            </Col>

            {/* Column 3 */}
            <Col lg={4} md={6} sm={6} xs={12} className="d-flex flex-column">
              <Row className="h-100 flex-grow-1">
                <Col lg={6} sm={6} xs={6} className="d-flex flex-column">
                  <div
                    className="offer-box d-flex flex-column flex-grow-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/marketing-cloud";
                    }}
                  >
                    <div className="mt-auto">
                      <h3 className="text-break">Marketing Cloud</h3>
                      <p className="text-left">
                        Automate journeys to connect seamlessly across channels.
                      </p>
                    </div>
                    <Nav.Link as={Link} to="../marketing-cloud">
                      <Image
                        src={arrow}
                        className="arrow mt-2 align-self-start"
                      />
                    </Nav.Link>
                  </div>
                </Col>
                <Col
                  lg={6}
                  sm={6}
                  xs={6}
                  className="d-flex align-items-stretch"
                >
                  <Image
                    className="w-100 h-100 object-fit-cover"
                    src={offerImageTwo}
                  />
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="h-100 mt-3">
            {/* Column 1 */}
            <Col
              lg={4}
              md={6}
              sm={6}
              xs={12}
              className="d-flex flex-column  mb-3 mb-sm-0"
            >
              <Row className="h-100 flex-grow-1">
                <Col
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className="d-flex align-items-stretch"
                >
                  <Image
                    className="w-100 h-100 object-fit-cover"
                    src={offerImageThree}
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={6} className="d-flex flex-column">
                  <div
                    className="offer-box d-flex flex-column flex-grow-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/marketing-cloud-personalization";
                    }}
                  >
                    <div className="mt-auto">
                      <h3 className="text-break">Marketing Personalization</h3>
                      <p className="text-left text-break">
                        Deliver real-time experiences where it matters most.
                      </p>
                    </div>
                    <Nav.Link as={Link} to="../marketing-cloud-personalization">
                      <Image
                        src={arrow}
                        className="arrow mt-2 align-self-start"
                      />
                    </Nav.Link>
                  </div>
                </Col>
              </Row>
            </Col>

            {/* Column 2 */}
            <Col lg={4} md={6} sm={6} xs={12} className="d-flex flex-column">
              <Row className="h-100 flex-grow-1">
                <Col
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className="d-flex align-items-stretch"
                >
                  <Image
                    className="w-100 h-100 object-fit-cover"
                    src={offerImageSeven}
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={6} className="d-flex flex-column">
                  <div
                    className="offer-box d-flex flex-column flex-grow-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/service-cloud";
                    }}
                  >
                    <div className="mt-auto">
                      <h3 className="text-break">Sales and Service Cloud</h3>
                      <p className="text-left">
                        Empower agents to provide seamless, omnichannel support.
                      </p>
                    </div>
                    <Nav.Link as={Link} to="../service-cloud">
                      <Image
                        src={arrow}
                        className="arrow mt-2 align-self-start"
                      />
                    </Nav.Link>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="h-100 mt-3">
            {/* Empty Column for Large Screens Only */}
            {/* <Col lg={4} className="d-lg-block d-none">
              <div className="text-center h-bx d-flex align-items-center justify-content-center"></div>
            </Col> */}

            {/* Column 1 */}
            <Col lg={4} md={6} sm={6} xs={12} className="d-flex flex-column">
              <Row className="h-100 flex-grow-1 mb-3 mb-sm-0">
                <Col lg={6} md={6} sm={6} xs={6} className="d-flex flex-column">
                  <div
                    className="offer-box d-flex flex-column flex-grow-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/agent-force";
                    }}
                  >
                    <div className="mt-auto">
                      <h3 className="text-break">Agentforce</h3>
                      <p className="text-left">
                        Enable agents with tools to drive productivity and
                        impact.
                      </p>
                    </div>
                    <Nav.Link as={Link} to="../agent-force">
                      <Image
                        src={arrow}
                        className="arrow mt-2 align-self-start"
                      />
                    </Nav.Link>
                  </div>
                </Col>
                <Col
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className="d-flex align-items-stretch"
                >
                  <Image
                    className="w-100 h-100 object-fit-cover"
                    src={offerImageSix}
                  />
                </Col>
              </Row>
            </Col>
            {/* Column 2 */}
            <Col lg={4} md={6} sm={6} xs={12} className="d-flex flex-column">
              <Row className="h-100 flex-grow-1">
                <Col lg={6} md={6} sm={6} xs={6} className="d-flex flex-column">
                  <div
                    className="offer-box d-flex flex-column flex-grow-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/slack";
                    }}
                  >
                    <div className="mt-auto">
                      <h3 className="text-break">Slack</h3>
                      <p className="text-left">
                        Turn conversations into action, instantly
                      </p>
                    </div>
                    <Nav.Link as={Link} to="../slack">
                      <Image
                        src={arrow}
                        className="arrow mt-2 align-self-start"
                      />
                    </Nav.Link>
                  </div>
                </Col>
                <Col
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className="d-flex align-items-stretch"
                >
                  <Image
                    className="w-100 h-100 object-fit-cover"
                    src={offerImageEleven}
                  />
                </Col>
              </Row>
            </Col>
            {/* Column 2 */}
            <Col lg={4} md={6} sm={6} xs={12} className="d-flex flex-column">
              <Row className="h-100 mt-3 mt-lg-0 flex-grow-1">
                <Col lg={6} md={6} sm={6} xs={6} className="d-flex flex-column">
                  <div
                    className="offer-box d-flex flex-column flex-grow-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/AI-Lab-ODC";
                    }}
                  >
                    <div className="mt-auto">
                      <h3 className="text-break">AI Lab</h3>
                      <p className="text-left">
                        Your space to explore, experiment, and transform with
                        Artificial Intelligence.
                      </p>
                    </div>
                    <Nav.Link as={Link} to="../AI-Lab-ODC">
                      <Image
                        src={arrow}
                        className="arrow mt-2 align-self-start"
                      />
                    </Nav.Link>
                  </div>
                </Col>
                <Col
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className="d-flex align-items-stretch"
                >
                  <Image
                    className="w-100 h-100 object-fit-cover"
                    src={offerImageEight}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <Row className="h-100 mt-3">
            {/* Column 1 */}
            <Col lg={4} md={6} sm={6} xs={12} className="d-flex flex-column">
              <Row className="h-100 flex-grow-1  mb-3 mb-sm-0">
                <Col
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className="d-flex align-items-stretch"
                >
                  <Image
                    className="w-100 h-100 object-fit-cover"
                    src={offerImageFour}
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={6} className="d-flex flex-column">
                  <div
                    className="offer-box d-flex flex-column flex-grow-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/loyalty-management";
                    }}
                  >
                    <div className="mt-auto">
                      <h3 className="text-break">Loyalty Management</h3>
                      <p className="text-left">
                        Nurture relationships and create lasting loyalty with
                        your customers
                      </p>
                    </div>
                    <Nav.Link as={Link} to="../loyalty-management">
                      <Image
                        src={arrow}
                        className="arrow mt-2 align-self-start"
                      />
                    </Nav.Link>{" "}
                  </div>
                </Col>
              </Row>
            </Col>

            {/* Column 2 */}
            <Col lg={4} md={6} sm={6} xs={12} className="d-flex flex-column">
              <Row className="h-100 flex-grow-1">
                <Col
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className="d-flex align-items-stretch"
                >
                  <Image
                    className="w-100 h-100 object-fit-cover"
                    src={offerImageFive}
                  />
                </Col>
                <Col lg={6} md={6} sm={6} xs={6} className="d-flex flex-column">
                  <div
                    className="offer-box d-flex flex-column flex-grow-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/tableau";
                    }}
                  >
                    <div className="mt-auto">
                      <h3 className="text-break">Tableau</h3>
                      <p className="text-left">
                        Discover answers to business-critical questions with a
                        holistic, real-time view of your relevant data.
                      </p>
                    </div>
                    <Nav.Link as={Link} to="../tableau">
                      <Image
                        src={arrow}
                        className="arrow mt-2 align-self-start"
                      />
                    </Nav.Link>
                  </div>
                </Col>
              </Row>
            </Col>

            {/* Empty Column for Large Screens Only */}
            <Col lg={4} className="d-lg-block d-none">
              <div className="text-center h-bx d-flex align-items-center justify-content-center"></div>
            </Col>
          </Row>

          <Row className="h-100 mt-3">
            {/* Empty Column for Large Screens Only */}
            <Col lg={4} className="d-lg-block d-none">
              <div className="text-center h-bx d-flex align-items-center justify-content-center"></div>
            </Col>

            {/* Column 1 */}
            <Col lg={4} md={6} sm={6} xs={12} className="d-flex flex-column">
              <Row className="h-100 flex-grow-1 mb-3 mb-sm-0">
                <Col lg={6} md={6} sm={6} xs={6} className="d-flex flex-column">
                  <div
                    className="offer-box d-flex flex-column flex-grow-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/engineering";
                    }}
                  >
                    <div className="mt-auto">
                      <h3 className="text-break">Engineering</h3>
                      <p className="text-left">
                        Built with clarity. Scaled with purpose. Enhanced by AI.
                      </p>
                    </div>
                    <Nav.Link as={Link} to="../engineering">
                      <Image
                        src={arrow}
                        className="arrow mt-2 align-self-start"
                      />
                    </Nav.Link>
                  </div>
                </Col>
                <Col
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className="d-flex align-items-stretch"
                >
                  <Image
                    className="w-100 h-100 object-fit-cover"
                    src={offerImageNine}
                  />
                </Col>
              </Row>
            </Col>

            {/* Column 2 */}
            <Col lg={4} md={6} sm={6} xs={12} className="d-flex flex-column">
              <Row className="h-100 flex-grow-1">
                <Col lg={6} md={6} sm={6} xs={6} className="d-flex flex-column">
                  <div
                    className="offer-box d-flex flex-column flex-grow-1"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = "/global-capability-center/GCC";
                    }}
                  >
                    <div className="mt-auto">
                      <h3 className="text-break">GCC</h3>
                      <p className="text-left">
                        Comsense Global Capability Centre
                      </p>
                    </div>
                    <Nav.Link as={Link} to="../global-capability-center/GCC">
                      <Image
                        src={arrow}
                        className="arrow mt-2 align-self-start"
                      />
                    </Nav.Link>
                  </div>
                </Col>
                <Col
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                  className="d-flex align-items-stretch"
                >
                  <Image
                    className="w-100 h-100 object-fit-cover"
                    src={offerImageTen}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section class="page-section pt-80 pb-80 bg-white">
        <Container>
          <Row className="justify-content-center">
            <Col lg={11}>
              <Row className="mb-4">
                <Col lg={12} className="mb-3">
                  <span
                    className="fw-600 ls-minus036 fancy-text3 ps-2 d-block mb-0 pe-3 z-0 text-EE0000  position-relative overflow-hiddens text-white fs-20"
                    style={{ color: "#EE0000 !important" }}
                  >
                    Comsense in Numbers
                  </span>
                </Col>
              </Row>

              <Row className="align-items-center mt-0 justify-content-start testimonials-area position-relative">
                <Col
                  lg={3}
                  md={3}
                  sm={6}
                  xs={12}
                  className="cus-col-sm text-left"
                >
                  <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                    <h5 className="text-252B42 mb-3 fs--2 fw-700 fs-7 fs--4">
                      Top Partners
                    </h5>
                    <p
                      className="text-252B42 fw-400 pt-3 fs-6 fs--2 HelveticaRegular width-fit pe-4 border-1 border-252B42 border-dark border-top"
                      style={{ border: "0" }}
                    >
                      of Salesforce
                    </p>
                  </div>
                </Col>
                <Col
                  lg={3}
                  md={3}
                  sm={6}
                  xs={12}
                  className="cus-col-sm text-left"
                >
                  <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                    <h5 className="text-252B42 mb-3 fw-700 fs-7 fs--4">100+</h5>
                    <p
                      className="text-252B42 fw-400 pt-3 fs--2 fs-6 HelveticaRegular width-fit pe-4 border-1 border-252B42 border-dark border-top"
                      style={{ borderTop: " 1px solid #067BB1", border: "0" }}
                    >
                      Salesforce Certificates
                    </p>
                  </div>
                </Col>
                <Col
                  lg={3}
                  md={3}
                  sm={6}
                  xs={12}
                  className="cus-col-sm text-left"
                >
                  <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                    <h5 className="text-252B42 mb-3 fw-700 fs-7 fs--4">115+</h5>
                    <p
                      className="text-252B42 fw-400 pt-3 fs-6 fs--2 width-fit pe-4 HelveticaRegular border-1 border-252B42 border-dark border-top"
                      style={{ border: "0" }}
                    >
                      Team Strength
                    </p>
                  </div>
                </Col>
                <Col
                  lg={3}
                  md={3}
                  sm={6}
                  xs={12}
                  className="cus-col-sm text-left"
                >
                  <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                    <h5 className="text-252B42 mb-3 fw-700 fs-7 fs--4">300+</h5>
                    <p
                      className="text-252B42 fw-400 pt-3 fs-6 fs--2 HelveticaRegular width-fit pe-4 border-1 border-252B42 border-dark border-top"
                      style={{ border: "0" }}
                    >
                      Man Years Experience
                    </p>
                  </div>
                </Col>
              </Row>
              <Row className="align-items-center mt-3 justify-content-start testimonials-area position-relative">
                <Col
                  lg={3}
                  md={3}
                  sm={6}
                  xs={12}
                  className="cus-col-sm text-left"
                >
                  <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                    <h5 className="text-252B42 mb-3 fw-700 fs-7 fs--4">
                      Power of 3
                    </h5>
                    <p
                      className="text-252B42 fw-400 pt-3 fs--2 fs-6 HelveticaRegular width-fit pe-4 border-1 border-252B42 border-dark border-top"
                      style={{ border: "0" }}
                    >
                      Capabilities | Products | Managed Ops
                    </p>
                  </div>
                </Col>
                <Col
                  lg={3}
                  md={3}
                  sm={6}
                  xs={12}
                  className="cus-col-sm text-left"
                >
                  <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                    <h5 className="text-252B42 mb-3 fw-700 fs-7 fs--4">
                      12+ Years{" "}
                    </h5>
                    <p
                      className="text-252B42 fw-400 pt-3 fs-6 fs--2 HelveticaRegular width-fit pe-4 border-1 border-252B42 border-dark border-top"
                      style={{ borderTop: " 1px solid #067BB1", border: "0" }}
                    >
                      of Martech Experience
                    </p>
                  </div>
                </Col>
                <Col
                  lg={3}
                  md={3}
                  sm={6}
                  xs={12}
                  className="cus-col-sm text-left"
                >
                  <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                    <h5 className="text-252B42 mb-3 fw-700 fs-7 fs--4">45+​</h5>
                    <p
                      className="text-252B42 fw-400 pt-3 fs-6 fs--2 width-fit pe-4 HelveticaRegular border-1 border-252B42 border-dark border-top"
                      style={{ border: "0" }}
                    >
                      Global Clients
                    </p>
                  </div>
                </Col>
                <Col
                  lg={3}
                  md={3}
                  sm={6}
                  xs={12}
                  className="cus-col-sm text-left"
                >
                  <div className="mb-5 mb-lg-0 bg-transparent shadow-none">
                    <h5 className="text-252B42 mb-3 fw-700 fs-7 fs--4">4</h5>
                    <p
                      className="text-252B42 fw-400 pt-3 fs-6 fs--2 HelveticaRegular width-fit pe-4 border-1 border-252B42 border-dark border-top"
                      style={{ border: "0" }}
                    >
                      Global Locations
                    </p>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </section>

      <section class="bg-EFFDFF pt-80 pb-80">
        <Container>
          <Row className="align-items-center mb-5">
            <Col lg={6}>
              <div class="text-left">
                <h2 class="section-heading fw-700 fs-2 mb-3">
                  <span className="bordered-text bordered-text-start">
                    Why Now?
                  </span>
                </h2>
                <p className="text-252B42 fw-600 ls-0 mt-0 mb-2 fs-3">
                  The Sales<span className="fst-italic">f</span>orce + AI
                  Shift{" "}
                </p>
                <p className="mt-0 fs-5 fw-normal ls-0">
                  The next wave in CRM is here:{" "}
                  <span className="text-028bc6 fw-600">
                    Agent
                    <span style={{ fontStyle: "italic" }}>f</span>orce + Data
                    360
                  </span>
                  .
                </p>
                <p className="mt-0 fs-5 fw-normal ls-0">
                  Enterprises have invested heavily in{" "}
                  <span className="text-028bc6 fw-600">
                    Sales
                    <span style={{ fontStyle: "italic" }}>f</span>orce
                  </span>
                  , but fewer than 20% are truly ready for{" "}
                  <span className="text-028bc6 fw-600">AI</span>.
                </p>
                <p className="mt-0 fs-5 fw-normal ls-0">
                  The future of customer engagement depends on clean, connected,
                  and actionable data — powered by
                  <span className="text-028bc6 fw-600">
                    {" "}
                    Sales<span style={{ fontStyle: "italic" }}>f</span>orce Data
                    360 and Agent<span style={{ fontStyle: "italic" }}>f</span>
                    orce
                  </span>
                  .
                </p>
                <p className="mt-0 fs-5 fw-600 ls-0">
                  <span className="text-ee0000 fw-600">Comsense</span> helps you
                  close that readiness gap.
                </p>
              </div>
            </Col>
            <Col lg="6">
              <video
                className="w-100 video-shape"
                autoPlay
                loop
                muted
                playsInline
              >
                <source
                  src={require("../assets/images/Marketing/Banner 1 AI video.mp4")}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </Col>
          </Row>
          {/* <Row className="mt-4 text-left justify-content-center">
            <Col lg={11} md={12} className="mb-2 mb-lg-0">
              <p className="mt-0 fs-5 fw-normal ls-0">
                The next wave in CRM is here:{" "}
                <span className="text-028bc6 fw-600">
                  Agent
                  <span style={{ fontStyle: "italic" }}>f</span>orce + Data 360
                </span>
                .
              </p>
              <p className="mt-0 fs-5 fw-normal ls-0">
                Enterprises have invested heavily in{" "}
                <span className="text-028bc6 fw-600">
                  Sales
                  <span style={{ fontStyle: "italic" }}>f</span>orce
                </span>
                , but fewer than 20% are truly ready for{" "}
                <span className="text-028bc6 fw-600">AI</span>.
              </p>
              <p className="mt-0 fs-5 fw-normal ls-0">
                The future of customer engagement depends on clean, connected,
                and actionable data — powered by
                <span className="text-028bc6 fw-600">
                  {" "}
                  Sales<span style={{ fontStyle: "italic" }}>f</span>orce Data
                  360 and Agent<span style={{ fontStyle: "italic" }}>f</span>
                  orce
                </span>
                .
              </p>
              <p className="mt-0 fs-5 fw-600 ls-0">
                <span className="text-ee0000 fw-600">Comsense</span> helps you
                close that readiness gap.
              </p>
            </Col>
          </Row> */}
        </Container>
      </section>

      <section class="bg-E2F1FE pt-80 pb-80">
        <Container>
          <Row
            className="align-items-center mb-5 align-items-center justify-center"
            style={{ justifyContent: "center", textAlign: "center" }}
          >
            <Col lg={8}>
              <div class="text-center d-flex align-items-center justify-content-center position-relative">
                <h2 class="section-heading section-heading-center fw-700 fs-2">
                  We’ve Got the Expertise to Help You <br />
                  Move <span className="bordered-text">Faster</span> with{" "}
                  <span className="text-028bc6">
                    Sales<span style={{ fontStyle: "italic" }}>f</span>orce
                  </span>{" "}
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mt-6 testimonials-area position-relative">
            <Col lg={4} md={6}>
              <div className="help-box help-box-height mb-5 mb-lg-0 ps-3 pe-3">
                <div className="help-icon">
                  <Image className="" src={strategyAndConsultingIcon} />
                </div>
                <h5 className="mb-3 mt-2">Strategy & Consulting</h5>
                <p>
                  With deep Salesforce expertise, our consultants guide you in
                  choosing the best solutions to maximize your success.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6}>
              <div className="help-box  help-box-height mb-5 mb-lg-0">
                <div className="help-icon">
                  <Image className="" src={Implementation} />
                </div>
                <h5 className="mb-3 mt-2">Implementation</h5>
                <p>
                  We ensure smooth, end-to-end implementation & scalable
                  solutions that will leave you set up for success.
                </p>
              </div>
            </Col>
            <Col lg={4} md={6}>
              <div className="help-box  help-box-height">
                <div className="help-icon">
                  <Image className="" src={ManagedServices} />
                </div>
                <h5 className="mb-3 mt-2">Managed Services</h5>
                <p>
                  Our expert team becomes your trusted partner, managing and
                  optimizing Salesforce to keep everything running seamlessly.
                </p>
              </div>
            </Col>
            <Col lg={10} className="m-auto">
              <p className="mt-5 text-center fs-5 fw-normal ls-0">
                We’ve engineered ready-to-deploy accelerators that make
                Salesforce go live 30-40% faster, helps save 40%+ Data 360
                credits, and swiftly become AI-ready.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section class="bg-white pt-70 pb-70">
        <Container>
          <Row className="align-items-center mb-5">
            <Col col={12}>
              <div class="text-center d-flex align-items-center justify-content-center">
                <h2 class="section-heading section-heading-center fw-700 fs-2 mb-3">
                  What <span className="bordered-text">sets us</span> apart?
                </h2>
              </div>
              <p className="text-252B42 text-center fw-600 ls-0 mt-0 mb-2 fs-20">
                Built for the Agentforce Era
              </p>
            </Col>
          </Row>
          <Row className="align-items-center mt-4">
            <Col className="" lg={6} md={12}>
              <Image className="w-100" src={leftImageOne} />
            </Col>
            <Col className="px-3 px-lg-5 pt-3 pt-lg-0" lg={6} md={12}>
              <p className="text-252B42 fw-700 fs-26">Our Competitive Edge</p>
              <div className="sets-list">
                <h3 className="mt-1">Data-First DNA</h3>
                <p className="text-left mb-1">
                  6+ years of Salesforce Data 360 delivery, a decade in data
                  science & data engineering
                </p>
              </div>
              <div className="sets-list">
                <h3 className="mt-1">Domain Depth</h3>
                <p className="text-left mb-1">
                  Retail, Automotive, Real Estate, Consumer playbooks with Use
                  case & KPI frameworks
                </p>
              </div>
              <div className="sets-list">
                <h3 className="mt-1">Governance</h3>
                <p className="text-left mb-1">
                  Transparent delivery with measurable ROI
                </p>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mb-0 mt-4">
            <Col lg={10} className="offset-lg-1">
              <div class="text-center">
                <p className="text-252B42 ls-0 fw-500 fs-20">
                  We take ownership = Data × Domain × Delivery — built for the
                  Agent<span className="fst-italic">f</span>orce era.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* <section class="page-section bg-white">
                <Container>
                    <Row className='align-items-center mb-5'>
                        <Col col={12}>
                            <div class="text-center d-flex align-items-center justify-content-center position-relative">
                                <h2 class="section-heading section-heading-center">Hear from Our Happy Customers </h2>
                            </div>
                        </Col>
                    </Row>
                    <Row className='align-items-center mt-4 testimonials-area position-relative'>
                        <Col lg={12}>
                            <Image className='quote-icon' src={quote} />
                        </Col>
                        <Col lg={4} className='mb-3 mb-lg-0'>
                            <div className='client-quote'>
                                <div className='client-review'>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                </div>
                                <p>It has been a great journey with Comsense so far. The team is really supportive and helps us with regular insights to improve our ROI. There have been instances when they have gone out of their way to ensure that our campaigns are delivered on time. I look forward to a long and successful relationship with them. </p>
                                <div className='client-detail d-flex align-items-center justify-space-between'>
                                    <div>
                                        <h5>Vaibhav Bhardwaj</h5>
                                        <p>Brand Activation Manager Reebok India</p>
                                    </div>
                                    <Image src={clientReebok} />
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} className='mb-3 mb-lg-0'>
                            <div className='client-quote'>
                                <div className='client-review'>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                </div>
                                <p>It’s been a wonderful experience working with Comsense so far. The team provides updates & insights on a regular basis which is really helpful. The team is really supportive and ensures precise execution of campaigns in a timely manner. I wish them the very best & look forward to a long and successful relationship with them. </p>
                                <div className='client-detail d-flex align-items-center justify-between'>
                                    <div>
                                        <h5>Ankit Bhatnagar</h5>
                                        <p>Head CRM & Membership Adidas (India)</p>
                                    </div>
                                    <Image src={clientAdidas} />
                                </div>
                            </div>
                        </Col>
                        <Col lg={4} className='mb-3 mb-lg-0'>
                            <div className='client-quote'>
                                <div className='client-review'>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                    <i class="fa-solid fa-star"></i>
                                </div>
                                <p>It has been a great journey with Comsense so far. The team is really supportive and helps us with regular insights to improve our ROI. There have been instances when they have gone out of their way to ensure that our campaigns are delivered on time. I look forward to a long and successful relationship with them. </p>
                                <div className='client-detail d-flex align-items-center justify-space-between'>
                                    <div>
                                        <h5>Vaibhav Bhardwaj</h5>
                                        <p>Brand Activation Manager Reebok India</p>
                                    </div>
                                    <Image src={clientMetropolis} />
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section> */}

      <section className="bg-EFFDFF pt-80 pb-80">
        <Container>
          <Row className="align-items-center mb-0">
            <Col xs={12}>
              <div className="text-center d-flex align-items-center justify-content-center position-relative">
                <h2 class="section-heading section-heading-center fw-700 fs-2 mb-4 mb-sm-0">
                  Hear from Our <span className="bordered-text">Happy</span>{" "}
                  Customers
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center testimonials-area position-relative">
            <Col lg={12}>
              <Image className="quote-icon" src={quote} />
            </Col>
            <Col lg={12} className="mt-1">
              <Slider {...settings} className="mt-4">
                {/* Testimonial 4 */}
                <div className="px-sm-3 px-1 slide d-flex flex-column h-100">
                  <div className="client-quote d-flex flex-column h-100">
                    <div className="client-review">
                      {[...Array(5)].map((_, i) => (
                        <IoIosStar key={i} />
                      ))}
                    </div>
                    <p className="flex-grow-1">
                      During project scoping phase, the whole team led by Umang
                      interacted with all business owners along with us. Vishnu
                      critically evaluated data needs for each use case and
                      Wasim evaluated operational feasibility for all use cases.
                      With their expertise and help, we could not only define
                      use cases for first phase but also prioritize them
                      depending on requirements. Vishnu and his team dedicatedly
                      engaged with other stakeholders to resolve data related
                      issues to enable use cases. Umang under Sushil's guidance
                      has been a constant support for us to orchestrate the
                      whole project.
                    </p>
                    <div className="client-detail d-sm-flex d-xs-block align-items-center justify-content-between">
                      {/* <div>
                        <h5>Pratik Thaker</h5>
                        <p>
                          Senior Manager, Digital Acquisition & Marketing
                          Automation, Tata Motors
                        </p>
                      </div> */}
                      <Image
                        className="mt-3 mb-2 mb-sm-0 mt-sm-0"
                        src={clientTataMotors}
                      />
                    </div>
                  </div>
                </div>

                {/* Testimonial 5 */}
                <div className="px-sm-3 px-sm-1 slide d-flex flex-column h-100">
                  <div className="client-quote d-flex flex-column h-100">
                    <div className="client-review">
                      {[...Array(5)].map((_, i) => (
                        <IoIosStar key={i} />
                      ))}
                    </div>
                    <p className="flex-grow-1">
                      Comsense has played a pivotal role in our CRM, e-Commerce,
                      and digital transformation initiatives, leveraging their
                      forte in AI, ML, Data, and Advanced Analytics. For Adidas,
                      the consumer is at the heart of our strategy - right from
                      making the product, to selling it, to how we interact &
                      how we “connect” with the consumers matters most to us.
                      This, the Comsense team understood very well and partnered
                      with us to deliver a truly personalized & insights-driven
                      omnichannel customer experience using innovative
                      cross-industry use cases.
                    </p>
                    <div className="client-detail align-items-center d-sm-flex d-xs-block  align-items-center justify-content-between">
                      {/* <div>
                        <h5>Abhishek Sinha</h5>
                        <p>Head CRM & Membership - Emerging Markets, Adidas</p>
                      </div> */}
                      <Image
                        className="mt-3 mb-2 mb-sm-0 mt-sm-0"
                        src={clientAdidas}
                      />
                    </div>
                  </div>
                </div>
              </Slider>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="page-section bg-white pt-80 pb-80">
        <Container>
          <Row
            className="align-items-center mb-5 align-items-center justify-center"
            style={{ justifyContent: "center", textAlign: "center" }}
          >
            <Col lg={8}>
              <div class="text-center d-flex align-items-center justify-content-center position-relative">
                <h2 class="section-heading section-heading-center fw-700 fs-2">
                  <span className="bordered-text">Case Studies</span>{" "}
                </h2>
              </div>
            </Col>
          </Row>
          <Row className="align-items-center mb-2">
            <Col lg={12}>
              <div className="bg-E2F1FE box-shadow-one rounded-4">
                <Row className="align-items-center">
                  <Col lg={7} md={12}>
                    <div className="p-23">
                      <h4 className="mb-3 pb-0 ps-6 fs-26 lh-13">
                        How{" "}
                        <span className="text-ee0000">
                          AI-Powered Churn Models
                        </span>{" "}
                        Boosted Service Revenue & Reduced Complaints{" "}
                      </h4>
                      <p className="ls-minus036 mb-2 fs-6 fw-600 text-252B42">
                        A global two-wheeler manufacturer faced below challenges
                        in sustaining customer engagement after purchase:
                      </p>
                      <ul className="ps-2 mb-4 custom-ul">
                        <li className="ls-minus036 fs-12 mb-1 fw-400">
                          High drop-off post free-service cycle due to limited
                          visibility into at-risk customers
                        </li>
                        <li className="ls-minus036 fs-12 mb-1 fw-400">
                          Ineffective promotions due to non-contextualized
                          campaigns
                        </li>
                        <li className="ls-minus036 fs-12 mb-1 fw-400">
                          Inconsistent dealer operations
                        </li>
                      </ul>

                      <Nav.Link
                        className="d-inline-block  text-white btn btn-danger btn-xl me-3 ls-0 fw-600"
                        onClick={openCaseStudyModal}
                      >
                        Access Case Study
                      </Nav.Link>
                    </div>
                  </Col>
                  <Col lg={5} md={12} className="pe-3 pe-lg-0">
                    <div className="">
                      <Image
                        src={caseStudy}
                        className="w-100 rounded-right-bottom-4"
                      />
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      <section class="page-section bg-blue-gradient-two position-relative z-0 pt-80 pb-80">
        <Image
          src={LayerThree}
          className="position-absolute top-0 start-0 w-40"
        />
        <Container>
          <Row
            className="align-items-center mb-5 align-items-center justify-center"
            style={{ justifyContent: "center", textAlign: "center" }}
          >
            <Col lg={8}>
              <div class="text-center d-flex align-items-center justify-content-center position-relative">
                <h2
                  style={{ textShadow: "0px 4px 15px 0px #00000040;" }}
                  class="section-heading section-heading-center fw-700 fs-2 text-white"
                >
                  We’re Trusted by{" "}
                  <span className="bordered-text">Leading</span> Global
                  Brands{" "}
                </h2>
              </div>
            </Col>
          </Row>

          <Row className="align-items-center mt-1 testimonials-area position-relative">
            {/* <div className='client-area'>
                       <Image src={clientOne} />
                       <Image src={clientTwo} />
                       <Image src={clientThree} />
                       <Image src={clientTwo} />
                       </div> */}
            <div className="client-area logo-container">
              {clientImages.map((src, index) => (
                <Image
                  className="client-logo"
                  key={index}
                  src={src}
                  alt={`Client ${index + 1}`}
                />
              ))}
            </div>
          </Row>
        </Container>
        <Image
          src={LayerTwo}
          className="position-absolute bottom-0 end-0 w-40"
        />
      </section>

      <section className="page-section bg-white pt-80 pb-80">
        <Container>
          <div className="bg-E2F1FE position-relative box-shadow-one rounded-4 pt-5 p-23 p-sm-23">
            <Image
              src={LayerFour}
              className="position-absolute bottom-0 start-0 w-40"
            />

            <Row className="position-relative form-box z-0">
              {!enquirySent && (
              <Col lg={5}>
                <div class="text-left d-flex  justify-content-start">
                  <h2 class="section-heading fw-700 fs-2">
                    Let’s build the{" "}
                    <span className="text-ee0000">
                      {" "}
                      <br></br>
                      Agent<span className="fst-italic">f</span>orce era{" "}
                    </span>
                    - together.
                  </h2>
                </div>
              </Col>
              )}
              <Col lg={enquirySent ? 12 : 7}>
                {enquirySent ? (
                  <div
                    className="enquiry-success enquiry-success--row"
                    role="status"
                    aria-live="polite"
                  >
                    <Image src={enquirySuccess} alt="" className="enquiry-success-img" />
                    <div className="enquiry-success-body">
                      <h3 className="enquiry-success-title">Thank you</h3>
                      <p className="enquiry-success-subtitle">
                        We&rsquo;ve received your enquiry.
                      </p>
                      <p className="enquiry-success-text">
                        Our team will review your details and get in touch with
                        you soon. A confirmation has been sent to your inbox.
                      </p>
                      <div className="enquiry-success-actions">
                        <button
                          type="button"
                          className="enquiry-success-link"
                          onClick={() => setEnquirySent(false)}
                        >
                          <RotateCcw size={15} /> Submit another enquiry
                        </button>
                      </div>
                    </div>
                  </div>
                ) : (
                <Form onSubmit={handleSubmit}>
                  <Row className="pb-3 mt-3 mt-lg-0">
                    <Col lg={6}>
                      <>
                        <Form.Label htmlFor="inputPassword5">
                          Full Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                        />
                      </>
                    </Col>
                    <Col lg={6}>
                      <>
                        <Form.Label>Business Email</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                        />
                      </>
                    </Col>
                    <Col lg={6}>
                      <>
                        <Form.Label>Mobile Number</Form.Label>
                        <Form.Control
                          type="text"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                        />
                      </>
                    </Col>
                    <Col lg={6}>
                      <>
                        <Form.Label htmlFor="CompanyName">
                          Company Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="company"
                          value={formData.company}
                          onChange={handleChange}
                        />
                      </>
                    </Col>
                    <Col lg={12}>
                      <>
                        <Form.Label htmlFor="Message">Message</Form.Label>
                        <Form.Control
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          as="textarea"
                          rows={4}
                        />
                      </>
                    </Col>
                    <Col lg={12} className="mt-4 text-start">
                      <>
                        {/* <a class="btn btn-danger btn-xl me-3 ls-0 fw-600" href="#">Submit</a> */}
                        <Button
                          variant=""
                          type="submit"
                          className="fw-600 d-block btn btn-danger btn-xl"
                          disabled={loading}
                        >
                          {loading ? "Submitting..." : "Submit"}
                        </Button>
                      </>
                    </Col>
                    {responseMessage && (
                      <p
                        className="mt-3 mb-0 fs-12 text-center"
                        style={{ color: loading ? "blue" : "red" }}
                      >
                        {responseMessage}
                      </p>
                    )}
                  </Row>
                </Form>
                )}
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      <Modal
        show={showDataReadinessModal}
        size="xl"
        onHide={closeDataReadinessModal}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ overflow: "hidden" }}
      >
        <style>
          {`.btn-close {
          position: absolute;
          top: 1rem;
          right: 1rem;
          z-index: 2;
        }
        .modal-content{overflow:hidden !important;}
        
        `}
        </style>
        <Modal.Header className="p-0" closeButton></Modal.Header>
        <Modal.Body className="p-0">
          <DataReadinessModal />
        </Modal.Body>
      </Modal>

      <Modal
        show={showCaseStudyModal}
        size="xl"
        onHide={closeCaseStudyModal}
        className="CaseStudyModal"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        style={{ overflow: "hidden" }}
      >
        <style>
          {`.btn-close {
          position: absolute;
          top: 1rem;
          right: 1rem;
          z-index: 2;
        }
        .modal-content{overflow:hidden !important;}
        
        `}
        </style>
        <Modal.Header className="p-0" closeButton></Modal.Header>
        <Modal.Body className="p-0">
          <CaseStudyModal />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Home;
